module.exports = __webpack_public_path__ + "static/banner-a3ddcbf9217274b181cefea0ea7d69ea.png";